// C.1 — Аура Лидера улицы (фракционная пассивка нейтрального Героя).
//
// Правило:
//   - Аура работает, пока у игрока Герой Лидер улицы (neutral_lider_ulicy)
//     и он не Молчит.
//   - На 1-й линии (line=0) каждый союзный юнит получает +1/0/0.
//   - На 2-й линии (line=1) каждый союзный юнит получает +0/1/1.
//   - Бафф применяется ЛЮБОЙ фракции (включая нейтралов, фракционных,
//     призывных токенов).
//   - Молчание союзного юнита НЕ снимает бафф (это аура Героя, не свойство
//     юнита).
//
// Реализация по аналогии с reinforcement.js: PermanentBuff с sourceId
// 'street_leader:line<n>'. recomputeStreetLeaderAura(state) пересчитывает
// баффы при каждом изменении состава поля.

import { applyPermanentBuff, removePermanentBuffsBySource } from '../buffs.js';

export const STREET_LEADER_HERO_ID = 'neutral_lider_ulicy';
export const STREET_LEADER_SOURCE = 'street_leader';

function streetLeaderMatcher(sourceId) {
  return typeof sourceId === 'string' && sourceId.startsWith(STREET_LEADER_SOURCE);
}

export function recomputeStreetLeaderAura(state) {
  if (!state || !Array.isArray(state.players)) return;

  for (let pIdx = 0; pIdx < state.players.length; pIdx++) {
    const p = state.players[pIdx];
    if (!p) continue;

    if (!p.field) continue;

    // Снять старые баффы Лидера со всех юнитов игрока.
    for (let line = 0; line < 2; line++) {
      const row = p.field[line];
      if (!row) continue;
      for (const u of row) {
        if (!u) continue;
        removePermanentBuffsBySource(state, u, streetLeaderMatcher);
      }
    }

    // Проверяем, активен ли Герой Лидер улицы (и не молчит).
    const hero = p.hero;
    if (!hero || hero.id !== STREET_LEADER_HERO_ID) continue;
    if (hero.current?.silenced) continue;

    // Применяем баффы по линиям.
    for (let line = 0; line < 2; line++) {
      const row = p.field[line];
      if (!row) continue;
      const delta = (line === 0)
        ? { atk: 1, armor: 0, hp: 0 }
        : { atk: 0, armor: 1, hp: 1 };
      const sourceId = `${STREET_LEADER_SOURCE}:line${line}`;
      const sourceLabel = (line === 0)
        ? 'Лидер улицы (1-я линия)'
        : 'Лидер улицы (2-я линия)';
      for (const u of row) {
        if (!u) continue;
        applyPermanentBuff(state, u, delta, sourceId, sourceLabel);
      }
    }
  }
}

// Удобная обёртка с защитой от исключений (для регистрации в extra-handlers).
export function onStreetLeaderRelevantChange(state) {
  if (!state) return;
  try { recomputeStreetLeaderAura(state); } catch (e) {
    console.warn('[Корпы] recomputeStreetLeaderAura failed:', e?.message || e);
  }
}
